<section class="ab" *ngIf="task as t" [class.ab--waiting]="!t.canAct" aria-label="Approval">
  <!-- What is asked, and of whom. -->
  <div class="ab__head">
    <span class="ab__icon" aria-hidden="true">
      <svg viewBox="0 0 16 16" fill="none"><path d="M3.5 8.5l3 3 6-7" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" /></svg>
    </span>
    <div class="ab__text">
      <p class="ab__title" *ngIf="t.canAct">
        <strong>{{ asker }}</strong> asked you to approve <strong>{{ subject }}</strong>
      </p>
      <p class="ab__title" *ngIf="!t.canAct">
        Waiting on <strong>{{ t.assignedToName || (t.assignedToRole === 'admin' ? 'an admin' : 'the approver') }}</strong> to approve <strong>{{ subject }}</strong>
      </p>
      <p class="ab__meta">
        <span *ngIf="t.dueDate" [class.ab__overdue]="t.isOverdue">{{ t.isOverdue ? 'Overdue · was due' : 'Due' }} {{ t.dueDate | date:'d MMM' }}</span>
        <span *ngIf="t.priority === 'high'" class="ab__high">High priority</span>
        <span *ngIf="t.fields.length">Highlighted above</span>
      </p>
    </div>
  </div>

  <p class="ab__note" *ngIf="t.description">“{{ t.description }}”</p>

  <!-- Deciding. -->
  <ng-container *ngIf="t.canAct">
    <textarea *ngIf="rejecting" class="sd-input ab__comment" rows="2" [(ngModel)]="comment"
              placeholder="Why are you rejecting it?" aria-label="Reason for rejecting"></textarea>
    <p class="ab__error" *ngIf="error" role="alert">{{ error }}</p>
    <div class="ab__actions" *ngIf="!rejecting">
      <button type="button" class="sd-btn sd-btn--secondary ab__reject" [disabled]="!!busy" (click)="startReject()">Reject</button>
      <button type="button" class="sd-btn sd-btn--primary ab__approve" [disabled]="!!busy" (click)="approve()">
        {{ busy === 'approve' ? 'Approving…' : 'Approve' }}
      </button>
    </div>
    <div class="ab__actions" *ngIf="rejecting">
      <button type="button" class="sd-btn sd-btn--secondary" [disabled]="!!busy" (click)="rejecting = false; error = null">Back</button>
      <button type="button" class="sd-btn sd-btn--danger ab__approve" [disabled]="!!busy" (click)="confirmReject()">
        {{ busy === 'reject' ? 'Rejecting…' : 'Reject' }}
      </button>
    </div>
  </ng-container>

  <!-- Waiting on someone else. -->
  <ng-container *ngIf="!t.canAct">
    <p class="ab__error" *ngIf="error" role="alert">{{ error }}</p>
    <div class="ab__actions ab__actions--end" *ngIf="t.canCancel">
      <button type="button" class="ab__quiet" [disabled]="!!busy" (click)="cancelRequest()">
        {{ busy === 'cancel' ? 'Withdrawing…' : 'Withdraw request' }}
      </button>
    </div>
  </ng-container>
</section>
